import { createStandardAction } from 'typesafe-actions';
import { MenuStatus } from 'Menu-Types';

export const setMenuIsOpen = createStandardAction('SET_MENU_IS_OPEN')<MenuStatus>();
